import { SectionHeader } from "common/components/SectionHeader";
import React, { useContext } from "react";
import Typography from "@mui/material/Typography";
import { LanguageContext } from "configuration/app-context-manager/LanguageContext";
import Data from "./data/index.json";
import { Box, Container, Stack } from "@mui/material";

export const Privacy = () => {
  const { language } = useContext(LanguageContext);
  const data = Data[language];

  return (
    <Box mt={10} mb={12}>
      <SectionHeader title={data.title} subtitle={data.subtitle} />
      <Container maxWidth="md">
        <Typography
          sx={{
            textAlign: "center",
            fontSize: "0.8rem",
            letterSpacing: "0.08em",
            color: "#7a7a7a",
            mb: { xs: 5, md: 7 },
          }}
        >
          {data.lastUpdate}
        </Typography>
        <Stack spacing={4}>
          {data.sections.map((section, id) => (
            <Box key={id}>
              <Typography
                sx={{
                  fontFamily: "'Lato', sans-serif",
                  fontWeight: 700,
                  fontSize: "0.8rem",
                  letterSpacing: "0.15em",
                  textTransform: "uppercase",
                  color: "var(--clr-primary)",
                  mb: 1.5,
                }}
              >
                {section.heading}
              </Typography>
              <Typography
                sx={{
                  lineHeight: 1.9,
                  fontSize: { xs: "0.9rem", md: "0.95rem" },
                  color: "#4a4a4a",
                }}
              >
                {section.text}
              </Typography>
            </Box>
          ))}
        </Stack>
      </Container>
    </Box>
  );
};
